

















import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import CampaignCard from "@/components/CampaignCard.vue";

@Component({
  components: {
    CampaignCard,
  },
  computed: mapGetters(["allGenericCampaigns"]),
})
export default class GenericCampaignOverview extends Vue {}
